import * as React from 'react';

// Chartbeat headline test parses content for an <a> tag wrapping an <h> tag. This component
// provides that structure for testing without affecting screen readers or accessibility.
export const SilentAnchor = (props: React.HTMLProps<HTMLAnchorElement>) => {
  const { children, href } = props;

  return (
    <>
      {href ? (
        <a
          aria-hidden="true"
          tabIndex={-1}
          style={{
            pointerEvents: 'none',
            color: 'inherit',
            fontSize: 'inherit',
            fontWeight: 'inherit',
            lineHeight: 'inherit',
            textDecoration: 'inherit',
          }}
          {...props}
        >
          {children}
        </a>
      ) : (
        children
      )}
    </>
  );
};
